import CancelWarning from "./cancel-warning/PopupCancelWarning";
import PopupChannelCreateForm from "./channel-create/PopupChannelCreateForm";
import DeleteWarning from "./delete-warning/PopupDeleteWarning";
import FilePreviewPopup from "./file-preview/FilePreviewPopup";
import Form from "./form/PopupForm";
import LabelResidanceCertificate from "./label-residance-certificate/PopupLabelResidanceCertificateForm";
import WarningPopup from "./warning-popup/WarningPopup";

export default {
  DeleteWarning,
  CancelWarning,
  Form,
  WarningPopup,
  LabelResidanceCertificate,
  PopupChannelCreateForm,
  FilePreviewPopup,
};
